import React, { FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ResolverProps } from './Resolver.interface';
import { Loader } from '$shared/components';
import { resolverActions, resolverSelector } from '$store/resolver';
import { Button, Placeholder } from '$uikit';
import { Group, Profile, NotFound } from '$core';
import { useTranslator } from '$hooks';
import { authSelector } from '$store/auth';

export const Resolver: FC<ResolverProps> = ({ mode = 'address', domain }) => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const { isLoading, isLogged } = useSelector(authSelector);
  const { results, isFailed, isNotFound, isGeoBlocked } = useSelector(resolverSelector);
  const key = `${mode}_${domain}`;
  const info = results[key];

  useEffect(() => {
    dispatch(
      resolverActions.resolve({
        mode,
        domain,
      }),
    );
  }, [domain]);

  const handleRetry = useCallback(() => {
    dispatch(
      resolverActions.resolve({
        mode,
        domain,
      }),
    );
  }, [dispatch, mode, domain]);

  if (isNotFound[key]) {
    return <NotFound />;
  }

  if (isGeoBlocked[key]) {
    return (
      <Placeholder title={t('profile_geo_error_title')}>
        {t('profile_geo_error_caption')}
      </Placeholder>
    );
  }

  if (isFailed[key]) {
    return (
      <Placeholder
        centered
        title="Неудалось загрузить страницу"
        actions={
          <Button onClick={handleRetry} size="small">
            Попробовать еще
          </Button>
        }
      >
        Произошла ошибка либо страница еще не создана, попробуйте позже
      </Placeholder>
    );
  }

  if (!info || isLoading) {
    return <Loader isWrapped />;
  }

  switch (info.type) {
    case 'user':
      return <Profile profileId={info.id} />;
    case 'group':
      return <Group groupId={info.id} />;
    default:
      return <NotFound />;
  }
};
